import { CdnService } from '@/common/services/cdn/cdn.service';
import { Blog } from '@/core/domain/blog/models/blog.model';
import { GetBlogsUseCase } from '@/core/domain/blog/usecases/getBlogs.usecase';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'fe-blog-cards',
    templateUrl: './blog-cards.component.html',
    styleUrls: ['./blog-cards.component.scss'],
})
export class BlogCardsComponent implements OnInit {
    blog?: Blog;
    placeholders = new Array(3);

    constructor(private readonly getBlogsUseCase: GetBlogsUseCase) {}

    ngOnInit(): void {
        this.getBlogs();
    }

    onImageError(event: Event) {
        const target = event.target as HTMLImageElement;
        target.src = CdnService.url('images/nopic.webp');
    }

    public getBlogs(): void {
        this.getBlogsUseCase.execute().subscribe((blog) => {
            this.blog = blog;
        });
    }
}
